import { Badge, Flex } from '@chakra-ui/react'
import { statuses } from './RequestConsts'

interface ILogs {
  changed_in: string
  old_status: string
  new_status: string
  user: {
    name: string
  }
}

interface IRequestStatusLogProps {
  logs: ILogs[]
}

function formatDate(date: string) {
  date = new Date(`${date}Z`).toLocaleString('pt-BR', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: 'numeric'
  })

  return date
}

export function RequestStatusLog({ logs }: IRequestStatusLogProps) {
  return (
    <>
      {(logs == undefined || logs.length === 0) && <div className="text-center">Sem alterações de status registradas.</div>}
      {logs != undefined && logs.map((log, index) => (
        <Flex key={index} className="mb-2" alignItems="center">
          <Badge
            colorScheme={statuses?.[log.old_status] ? statuses[log.old_status].color : 'gray'}
            color={statuses?.[log.old_status] ? statuses[log.old_status].textColor : 'black'}
            mr={1}
          >
            {statuses?.[log.old_status] ? statuses[log.old_status].text : log.old_status}
          </Badge>
          &#8594;
          <Badge
            colorScheme={statuses?.[log.new_status] ? statuses[log.new_status].color : 'gray'}
            color={statuses?.[log.new_status] ? statuses[log.new_status].textColor : 'black'}
            ml={1}
            mr={2}
          >
            {statuses?.[log.new_status] ? statuses[log.new_status].text : log.new_status}
          </Badge>
          <small className="ml-2 text-gray-500">
            por <strong>{log.user.name}</strong> em {formatDate(log.changed_in)}
          </small>
        </Flex>
      ))}
    </>
  )
}
